import * as React from 'react';

type Position = None | Nav | Tooltip;

interface None {
  kind: 'none';
}

interface Nav {
  kind: 'nav';
}

interface Tooltip {
  kind: 'tooltip';
}

const PositionContext = React.createContext<Position>({ kind: 'none' });

export default PositionContext;
